var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.20833 7.08366L6.375 4.25033V9.91699L9.20833 7.08366ZM14.1667 7.08366C14.1667 8.06352 13.9807 8.98435 13.6089 9.84616C13.237 10.708 12.7323 11.4576 12.0948 12.0951C11.4573 12.7326 10.7076 13.2373 9.84583 13.6092C8.98403 13.9811 8.06319 14.167 7.08333 14.167C6.10347 14.167 5.18264 13.9811 4.32083 13.6092C3.45903 13.2373 2.70938 12.7326 2.07188 12.0951C1.43438 11.4576 0.929688 10.708 0.557813 9.84616C0.185938 8.98435 0 8.06352 0 7.08366C0 6.1038 0.185938 5.18296 0.557813 4.32116C0.929688 3.45935 1.43438 2.7097 2.07188 2.0722C2.70938 1.4347 3.45903 0.930013 4.32083 0.558138C5.18264 0.186263 6.10347 0.000325203 7.08333 0.000325203C8.06319 0.000325203 8.98403 0.186263 9.84583 0.558138C10.7076 0.930013 11.4573 1.4347 12.0948 2.0722C12.7323 2.7097 13.237 3.45935 13.6089 4.32116C13.9807 5.18296 14.1667 6.1038 14.1667 7.08366ZM12.75 7.08366C12.75 5.50171 12.201 4.16178 11.1031 3.06387C10.0052 1.96595 8.66528 1.41699 7.08333 1.41699C5.50139 1.41699 4.16146 1.96595 3.06354 3.06387C1.96563 4.16178 1.41667 5.50171 1.41667 7.08366C1.41667 8.6656 1.96563 10.0055 3.06354 11.1034C4.16146 12.2014 5.50139 12.7503 7.08333 12.7503C8.66528 12.7503 10.0052 12.2014 11.1031 11.1034C12.201 10.0055 12.75 8.6656 12.75 7.08366Z",
    fill: "#F04D23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.14b4d57db8a5c571ccfc41649c7dd138.svg";
export { ForwardRef as ReactComponent };